import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vShow as _vShow, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "navbar fixed-bottom navbar-dark bg-dark" }
const _hoisted_5 = { class: "container d-flex justify-content-center" }
const _hoisted_6 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_7 = { class: "btn btn-secondary" }
const _hoisted_8 = { class: "text-lowercase d-none d-sm-inline" }
const _hoisted_9 = { class: "btn btn-secondary" }
const _hoisted_10 = { class: "text-lowercase d-none d-sm-inline" }
const _hoisted_11 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "btn btn-light mr-auto" }
const _hoisted_14 = {
  class: "progress mx-2 w-50",
  style: {"height":"38px","background-color":"#D3D3D3"}
}
const _hoisted_15 = { style: {"padding-top":"80px","padding-bottom":"120px"} }
const _hoisted_16 = {
  id: "top",
  class: "mt-4"
}
const _hoisted_17 = { class: "font-weight-light" }
const _hoisted_18 = { class: "text-lowercase" }
const _hoisted_19 = { class: "navbar navbar-expand-md navbar-light bg-light" }
const _hoisted_20 = { class: "navbar-nav" }
const _hoisted_21 = { class: "nav-item dropdown" }
const _hoisted_22 = {
  class: "nav-link dropdown-toggle",
  id: "navbarDropdown",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_23 = { class: "dropdown-menu" }
const _hoisted_24 = { class: "badge badge-secondary" }
const _hoisted_25 = { class: "badge badge-secondary" }
const _hoisted_26 = { class: "badge badge-secondary" }
const _hoisted_27 = { class: "badge badge-secondary" }
const _hoisted_28 = { class: "badge badge-secondary" }
const _hoisted_29 = { class: "badge badge-secondary" }
const _hoisted_30 = { class: "badge badge-secondary" }
const _hoisted_31 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_32 = { class: "mt-5 mb-3 lead" }
const _hoisted_33 = { class: "text-lowercase" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativeDetailsDialog = _resolveComponent("AlternativeDetailsDialog")!
  const _component_AttributeDescriptionDialog = _resolveComponent("AttributeDescriptionDialog")!
  const _component_SurveyVoteEditor = _resolveComponent("SurveyVoteEditor")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AlternativeDetailsDialog, { viewModel: _ctx.alternativeDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AttributeDescriptionDialog, { viewModel: _ctx.attributeDescriptionDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading...", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("nav", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, [
                    _cache[14] || (_cache[14] = _createElementVNode("i", {
                      class: "fa fa-angle-double-left",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */)),
                    _cache[15] || (_cache[15] = _createTextVNode(" Prev ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.AlternativeLabel), 1 /* TEXT */)
                  ])), [
                    [_directive_sanitizedHref, _ctx.PrevAlternativeUrl]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-warning",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ScrollTopCommand && _ctx.ScrollTopCommand(...args)))
                  }, " Back to Top "),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, [
                    _cache[16] || (_cache[16] = _createTextVNode(" Next ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.AlternativeLabel), 1 /* TEXT */),
                    _cache[17] || (_cache[17] = _createElementVNode("i", {
                      class: "fa fa-angle-double-right",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */))
                  ])), [
                    [_directive_sanitizedHref, _ctx.NextAlternativeUrl]
                  ])
                ])
              ])
            ]),
            _createElementVNode("nav", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" My Survey ", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, _ctx.DashboardUrl]
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    role: "progressbar",
                    style: _normalizeStyle({width: _ctx.Progress + '%'})
                  }, _toDisplayString(_ctx.ProgressStr), 5 /* TEXT, STYLE */)
                ]),
                _withDirectives(_createElementVNode("button", {
                  type: "button",
                  class: "btn btn-warning",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Save && _ctx.Save(...args)))
                }, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                  _createTextVNode(" Saving... ", -1 /* CACHED */)
                ]))], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.IsSaved == null]
                ]),
                _withDirectives(_createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.Save && _ctx.Save(...args)))
                }, " Saved ", 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.IsSaved === true]
                ]),
                _withDirectives(_createElementVNode("button", {
                  type: "button",
                  class: "btn btn-warning",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.Save && _ctx.Save(...args)))
                }, " Save ", 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.IsSaved === false]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h3", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _cache[20] || (_cache[20] = _createTextVNode("Evaluate ", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.AlternativeLabel), 1 /* TEXT */),
                  _cache[21] || (_cache[21] = _createTextVNode(": ", -1 /* CACHED */))
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.Name), 1 /* TEXT */)
              ]),
              _cache[36] || (_cache[36] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
              _createElementVNode("nav", _hoisted_19, [
                _createElementVNode("ul", _hoisted_20, [
                  _createElementVNode("li", _hoisted_21, [
                    _createElementVNode("a", _hoisted_22, [
                      _cache[22] || (_cache[22] = _createTextVNode(" Questions: ", -1 /* CACHED */)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.QuestionsFilter), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.SetQuestionsFilterCommand('All')))
                      }, [
                        _cache[23] || (_cache[23] = _createTextVNode("All ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.QuestionsCount), 1 /* TEXT */)
                      ]),
                      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.SetQuestionsFilterCommand('Answered')))
                      }, [
                        _cache[24] || (_cache[24] = _createTextVNode("Answered ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.AnsweredQuestionsCount), 1 /* TEXT */)
                      ]),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.SetQuestionsFilterCommand('Not answered')))
                      }, [
                        _cache[25] || (_cache[25] = _createTextVNode("Not answered ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.NotAnsweredQuestionsCount), 1 /* TEXT */)
                      ]),
                      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.SetQuestionsFilterCommand('Has value')))
                      }, [
                        _cache[26] || (_cache[26] = _createTextVNode("Has value ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.VotedQuestionsCount), 1 /* TEXT */)
                      ]),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.SetQuestionsFilterCommand('No value')))
                      }, [
                        _cache[27] || (_cache[27] = _createTextVNode("No value ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.NotVotedQuestionsCount), 1 /* TEXT */)
                      ]),
                      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.SetQuestionsFilterCommand('Commented')))
                      }, [
                        _cache[28] || (_cache[28] = _createTextVNode("Commented ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.CommentedQuestionsCount), 1 /* TEXT */)
                      ]),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.SetQuestionsFilterCommand('Not commented')))
                      }, [
                        _cache[29] || (_cache[29] = _createTextVNode("Not commented ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.NotCommentedQuestionsCount), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("form", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control mr-sm-2",
                    type: "search",
                    placeholder: "Filter attributes",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.SearchPhrase]
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QuestionsView, (q) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createElementVNode("p", _hoisted_32, [
                    _createElementVNode("strong", null, _toDisplayString(q.OrderValue) + ".", 1 /* TEXT */),
                    _cache[33] || (_cache[33] = _createTextVNode(" How would you rate ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.AlternativeLabel), 1 /* TEXT */),
                    _createElementVNode("a", {
                      class: "text-primary font-italic",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.ShowAlternativeDetailsCommand && _ctx.ShowAlternativeDetailsCommand(...args)))
                    }, _toDisplayString(_ctx.Name), 1 /* TEXT */),
                    _cache[34] || (_cache[34] = _createTextVNode(" in the context of ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (_ctx.ShowAttributeDetailsCommand(q))
                    }, _toDisplayString(q.AttributeName), 9 /* TEXT, PROPS */, _hoisted_34),
                    _cache[35] || (_cache[35] = _createTextVNode("? ", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_SurveyVoteEditor, {
                        Value: q.Value,
                        Comment: q.Comment,
                        HasAnswer: q.HasAnswer,
                        HasScale: q.HasScale,
                        ScaleLevels: q.ScaleLevels,
                        onUpdateValue: ($event: any) => (_ctx.handleVoteValueUpdate(q, $event)),
                        onUpdateComment: ($event: any) => (_ctx.handleVoteCommentUpdate(q, $event))
                      }, null, 8 /* PROPS */, ["Value", "Comment", "HasAnswer", "HasScale", "ScaleLevels", "onUpdateValue", "onUpdateComment"])
                    ])
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}